const frAuth = {
    signInTab: "Connexion",
    signUpTab: "Créer un compte",
    fullNamePlaceholder: "Nom complet",
    emailPlaceholder: "Adresse e-mail",
    passwordPlaceholder: "Mot de passe",
    confirmPasswordPlaceholder: "Confirmer le mot de passe",
    referralCodePlaceholder: "Code de parrainage (facultatif)",
    createMyAccount: "Créer mon compte",
    forgotPassword: "Mot de passe oublié ?",
    orSeparator: "ou",
    continueWithGoogle: "Continuer avec Google",
    termsNotice: "En créant un compte, vous acceptez nos conditions d'utilisation",
    authDialogDefaultReason: "Connectez-vous pour reprendre votre analyse là où vous l'aviez laissée",
    guardTitle: "Connectez-vous pour continuer",
    guardDefaultReason: "Cet écran demande un compte. Cela ne prend qu'un instant.",
    guardReasonAnalyze: "Connectez-vous pour analyser un match",
    guardReasonHistory: "Connectez-vous pour voir votre historique d'analyses",
    guardReasonAccount: "Connectez-vous pour ouvrir votre compte",

    invalidReferralCode: "Ce code de parrainage n'existe pas, vous pouvez laisser le champ vide",
    validCode: "Code valide",
    invitedYou: "{{name}} vous a invité",
    discountOffFirstPlan: "{{percent}}% sur votre première formule",

    enterEmail: "Saisissez votre adresse e-mail",
    enterPassword: "Saisissez votre mot de passe",
    enterName: "Saisissez votre nom",
    passwordsMustMatch: "Les deux mots de passe doivent être identiques",
    resetEmailFirst: "Saisissez d'abord votre adresse e-mail, le lien y sera envoyé",
    resetLinkSent: "Consultez votre boîte mail, un lien pour choisir un nouveau mot de passe arrive"
}

export default frAuth
